// components/SidebarExpanded.tsx
import React from 'react';
import {
  ViewSidebar,
  Search,
  History,
  PersonOutline,
  HelpOutline,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

type Props = {
  onToggle: () => void;
};

const SidebarExpanded: React.FC<Props> = ({ onToggle }) => {
  const navigate = useNavigate();
  return (
    <aside className="fixed top-0 left-0 h-full w-60 bg-white shadow-md z-50 border-r">
      <div className="flex flex-col justify-between h-full py-4">
        {/* 上部 */}
        <div>
          <div className="h-5 mb-6" />
          <ul className="space-y-2">
            <li
              className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={onToggle}
            >
              <ViewSidebar className="mr-3" />
            </li>
            <li
              className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => navigate('/search-entry')}
            >
              <Search className="mr-3" />
              <span>検索</span>
            </li>
            <li className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer">
              <History className="mr-3" />
              <span>履歴</span>
            </li>
          </ul>
        </div>

        {/* 下部 */}
        <div className="space-y-2">
          <div className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer">
            <PersonOutline className="mr-3" />
            <span>プロフィール</span>
          </div>
          <div className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer">
            <HelpOutline className="mr-3" />
            <span>ヘルプ</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default SidebarExpanded;
